<template>
  <div class="treeStore">
    <!-- 多级下拉 -->
    <div class="selectors" v-if="selectors.length > 0">
      <el-select
        v-for="(level, index) in selectors"
        :key="index"
        v-model="selected[index]"
        placeholder="请选择"
        @change="val => handleChange(index, val)"
        style="margin-right: 10px; width: 180px;"
      >
        <el-option
          v-for="item in level"
          :key="item.id"
          :label="item.name"
          :value="item.id" 
        />
      </el-select>
    </div>

    <!-- 门店搜索 + 多选 -->
    <div v-if="storeList.length" class="store-box">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索门店名称..."
        clearable
        size="small"
        style="margin: 10px 0; width: 300px;"
      />
      <div class="selectBox">
        <check-all-group 
          v-model="childCheckedStores"  
          :options="filteredStores"
          :isShowDivider="filteredStores.length > 3"
          :isCheckAll="isCheckAll"
          @change="checkAllChange"
          value-key="id"
          label-key="name"
          all-label="全选当前列表"
        />
      </div>
      
    </div>
    <!-- 门店统计 -->
    <div class="store-summary" v-if="checkedStoresInfoList.length > 0">
        <div>当前选择：</div>
        <div class="store-summary-total">Lann 品牌下共选择了 {{ checkedStoresInfoList.length }} 家门店</div>
        <!-- <div class="store-summary-tags">
          <el-tag
            style="margin: 0 5px 5px 0"
            v-for="(store, index) in checkedStoresInfoList" 
            :key="index"
            type="info" 
            closable 
            size="mini"
            @close="deleteStore(store)"
          >{{store.name}}</el-tag>
        </div> -->
      </div>
  </div>
</template>

<script>
import CheckAllGroup from "../select/select_checkAllGroup.vue"
import { extractStoreType2 } from "../../../common/util";
export default {
  name: "treeStore",
  components: {
    CheckAllGroup
  },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    checkedStoreIdList: {
      type: Array,
      default: () => []
    },
    // 门店树数据（从父组件传入）
    treeStoreData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      selectors: [],   // 多级下拉数据
      selected: [],             // 每级选中的数据
      storeList: [],            // 当前门店列表
      searchKeyword: "",
      checkedStores: [],
      checkAll: false,
      checkedStoresInfoList: [],
      isCheckAll: false,
      childCheckedStores: [], //子组件传入的selectedStoresID
      // allStoreInfoList: [],  //全部门店列表
    };
  },
  computed: {
    // 获取门店树数据（优先使用 prop，否则从 localStorage 读取）
    treeStoreArr() {
      if (this.treeStoreData && this.treeStoreData.length > 0) {
        return this.treeStoreData
      }
      // 兜底：从 localStorage 读取
      try {
        const localData = JSON.parse(localStorage.getItem("treeStore"))
        if (localData && localData.length > 0) {
          return localData
        }
      } catch (e) {}
      return []
    },
    allStoreInfoList() {
      if (!this.treeStoreArr || !this.treeStoreArr[0] || !this.treeStoreArr[0].subList || !this.treeStoreArr[0].subList[0]) {
        return []
      }
      let arr = extractStoreType2(this.treeStoreArr[0].subList[0] || [])
      this.$emit('update:allStoreInfoList',arr)
      return arr
    },
    filteredStores() {
      if (!this.searchKeyword) return this.storeList;
      return this.storeList.filter(store =>
        store.name.includes(this.searchKeyword)
      );
    },
  },
  
  watch:{
    // 监听 treeStoreData 变化，数据到达时重新加载
    treeStoreData: {
      handler(val) {
        if (val && val.length > 0) {
          this.fetchData()
        }
      },
      immediate: true
    },
    checkedStoreIdList(arr) {
      this.childCheckedStores = arr
    },

    storeList(arr) {
      let isChildCheckedArr = []
      arr.map(store => {
        if(this.checkedStores.includes(store.id)) {
          isChildCheckedArr.push(store.id)
        }
      })
      if(isChildCheckedArr.length === arr.length) {
        this.childCheckedStores = arr.map(store => store.id)
      } else {
        this.childCheckedStores = isChildCheckedArr
      }
    },
    resetFlag() {
      // 重置所有数据
      this.selected = [];
      this.checkedStores = [];
      this.checkedStoresInfoList = [];
      this.storeList = [];
      this.checkAll = false;
      // this.selectors = [treeStoreArr]; // 重新回到初始数据
      this.fetchData()
    },

    childCheckedStores(arr) {
      let newArr = arr

      newArr.map(id=>{
        if(!this.checkedStores.includes(id)){
          this.checkedStores.push(id)
        }
      })

      let unCludesIdArr = this.filteredStores.filter(store => {
        return !newArr.includes(store.id)
      })
      unCludesIdArr.map(store => {
        if(this.checkedStores.includes(store.id)) {
          this.checkedStores = this.checkedStores.filter(item => item !== store.id)
        }
      })
    },
    checkedStores(arr) {
      this.$emit("update:checkedStoreIdList", arr);
      const _this = this
      let selectedStoreInfo = []
      arr.map(id => {
        let store = _this.allStoreInfoList.find(
          store => store.id === id
        );
        if(store) {
          selectedStoreInfo.push(store)
        }
      })
      this.checkedStoresInfoList = selectedStoreInfo

    },
  },

  created() {
    this.fetchData()
  },
  
  methods: {

    fetchData() {
      // 检查数据是否存在
      if (!this.treeStoreArr || !this.treeStoreArr[0] || !this.treeStoreArr[0].subList || !this.treeStoreArr[0].subList[0]) {
        return
      }
      // 直接使用 Lann (id=6) 节点作为起点，删除品牌选择框
      let lannNode = this.treeStoreArr[0].subList[0]  // Lann 节点
      let firstDefaultData = [...[{id: -1, name: '全部', type: 2}], ...lannNode.subList]
      this.selectors = [firstDefaultData]  // 只有一个选择框
      this.selected = [firstDefaultData[0].id]  // 默认选中"全部"
      let allStoreList = extractStoreType2(lannNode)
      this.storeList = allStoreList
      this.checkedStoresInfoList = allStoreList
      this.checkedStores = allStoreList.map(store => store.id)
    },

    handleChange(index, id) {
      this.isCheckAll = false
      if(id === -1) {
        // 选择"全部"时，清除后面的选择框，只保留当前选择框
        this.selectors = this.selectors.slice(0, index + 1)
        this.selected = this.selected.slice(0, index + 1)
        this.storeList = [...this.allStoreInfoList]
        return
      }
      const selectedItem = this.selectors[index].find(item => item.id === id);

      // 保留前面的下拉框
      this.selectors = this.selectors.slice(0, index + 1);
      this.selected = this.selected.slice(0, index + 1);

      this.storeList = [];
      if (selectedItem && selectedItem.subList) {
        if (selectedItem.subList.length && selectedItem.subList[0].type === 2) {
          // 如果是门店层，叠加门店
          this.storeList = [...this.storeList, ...selectedItem.subList];
        } else {
          // 还有下级
          this.selectors.push(selectedItem.subList);
          this.storeList = extractStoreType2(selectedItem.subList)
        }
      
      } else if(selectedItem  && selectedItem.type === 2){
        this.storeList = [...this.storeList, ...[selectedItem]];
      }
    },

    deleteStore(store) {
      this.checkedStores = this.checkedStores.filter(id => id !== store.id);
      this.childCheckedStores = this.childCheckedStores.filter(id => id !== store.id);
      this.$emit('update:checkedStoreIdList', [...this.checkedStores]);
    },

    handleCheckAll(val) {
      this.checkedStores = val ? this.filteredStores : [];
    },

    checkAllChange() {
    }
  }
};
</script>

<style lang="less" scoped>
.treeStore {
  .selectors {
    display: flex;
    align-items: center;
    .el-select { 
      width: 25%;
    }

  }
}
.store-box {
  margin-top: 15px;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
}
.store-summary {
  margin-top: 10px;
  background-color: #F5F7FA;
  padding: 10px;
  display: flex;
  font-size: 12px;
  align-items: flex-start;
  .store-summary-tags {
    flex: 1;
  }
  .store-summary-total { 
    color: #717182;
    font-size: 12px;
  }
}
.selectBox {
  max-height: 300px;
  overflow-y: auto;
}
</style>
